module.exports = {
  DefaultDashboard: 'แดชบอร์ดเริ่มต้น',
  Edit: 'แก้ไข',
  PleaseSelectABranch: 'กรุณาเลือกสาขา',
  PleaseSelectADepartment: 'กรุณาเลือกแผนก',
  PleaseChooseDepartmentPersonnel: 'กรุณาเลือกพนักงานแผนก',
  BIDashboardSource: 'แหล่งที่มาแดชบอร์ด BI',
  SelectBIDashboardSource: 'กรุณาเลือกแหล่งที่มาแดชบอร์ด BI',
  BiExpiredTip: 'เรียนผู้ใช้ที่เคารพ โมดูล BI ที่ท่านซื้อหมดอายุแล้ว<br>กรุณาต่ออายุเพื่อใช้งานต่อ สามารถติดต่อพนักงานขายหรือบริการลูกค้า<br><div style="margin-top: 5px;">โมดูล BI จะถูกจำกัดการเข้าถึง แต่ข้อมูลจะยังถูกเก็บไว้ เมื่อต่ออายุแล้วจึงจะสามารถใช้งานได้อีกครั้ง</div>'
}
